export function clearLocalData(): void {
  localStorage.clear();
}
